import { useContext, useEffect, useState } from "react";
import { ButtonBar } from "../molecule/buttonBar";
import { MultipleChoice } from "../molecule/multipleChoice";
import { AssessmentTitle, QuizTitle } from "../molecule/assessmentTitle";
import { OrderAnswers } from "../molecule/orderAnswers";
import { MatchChoice } from "../molecule/MatchChoice";

import { TrueFalseChoice } from "../molecule/multipleChoice copy";
import { GridLayout, HorizontalLayout, VerticalLayout } from "./layout";
import { StandardComp } from "../atoms/standardComp";
import { LessonComp } from "./lessonComp";
import { QuizStepper } from "./quizStepper";
import { getAPI, postAPI, updateAPI } from "../api/api";
import {
  AssesmentFactory,
  AssessmentFactory,
} from "../factory/assessmentContentFactory";
import { PageContext } from "../App";
import ImageAssessmentComp from "../components/imageAssessmentComp";
import { Melding } from "../atoms/melding";
import { TimeBar } from "../molecule/timeBar"
import { OpenQuiz } from "../molecule/OpenQuiz";
import OpenAssessmentComp from "./openAssessmentComp";
import { StandardButton } from "../atoms/buttons";
import { icon } from "../functions/icons";
import { ToastContext } from "../App";
import { ScoreOverviewModal } from "./customModals";
import { VideoPlayer, VideoPlayerAssessment, VideoPlayerFull } from "../atoms/video";

export const AssementComp = () => {
  const navigationContext = useContext(PageContext);
  const toastContext = useContext(ToastContext);
  const [assessment, setAssessment] = useState([]);
  const [quizStructure, setQuizStructure] = useState([]);
  const [step, setActiveStep] = useState(0);
  const [matchedPairsState, setMatchedPairsState] = useState([]);
  const [message, setMessage] = useState("");
  const [showScoreModal, setShowScoreModal] = useState(false);
  const [animationClass, setAnimationClass] = useState("animate-in");
  const [maxReachedModule, setMaxReachedModule] = useState(0);
  const [avatarVideoMini, setAvatarVideoMini] = useState(true);
  const [collapsed, setCollapsed] = useState(false);  
  const [messageAnimation, setMessageAnimation] = useState(
    "fade-in-top-to-bottom"
  );
  const loading = false;
  useEffect(() => {
    var copyQuizStructure = [...quizStructure];
    copyQuizStructure.forEach((section) => {
      section.collapsed = false;
    });

    loadAssesments();

    loadCourseStructure();
  }, []);

  const loadAssesments = async () => {
    const query = `api/assessments?course=${navigationContext.sidebar.courseID}&id_course_enrollments=${navigationContext.sidebar.enrollment}`;
    const assessment = await getAPI(query);
    console.log("API Response:", assessment);
    setAssessment(assessment.data);
    if (assessment.data[0].start_position > 0) {
      setActiveStep(assessment.data[0].start_position - 1);
      return;
    }
    setActiveStep(0);
  };

  const loadCourseStructure = async () => {
    const query = `api/courses/lessons/${navigationContext.sidebar.courseID}/structure`;
    const courseStructure = await getAPI(query);
    courseStructure.data.filter(course => course.collapsed = true)
    var indexCounter = 0;
    courseStructure.data.forEach(lesson => {
      lesson.modules.forEach(module => {
        module.indexCounter = indexCounter
        indexCounter++
      }
      )
    })
    setQuizStructure(courseStructure.data);
  };
  const startModule = async (body) => {
    const query = "api/assessments/start";
    const id_lesson_progress = await postAPI(query, body);

    const copyQuiz = [...assessment];
    copyQuiz[step + 1]["id_lesson_progress"] = id_lesson_progress.data;
    setAssessment(copyQuiz);
  };
  const handleAnswer = async (body) => {
    const query = "api/assessments/answer";
    await updateAPI(query, body);
  };
  function selectQuestionId(id) {
    const copyQuiz = [...quizStructure];
    copyQuiz.forEach((section) => {
      section.active = false;
    });

    copyQuiz.forEach((section) => {
      section.questions.forEach((question) => {
        if (question.id === id) {
          question.active = true;
          section.active = true;
        } else {
          question.active = false;
        }
      });
    });
  }

  function toggleCollapse(id) {
    const copyQuiz = [...quizStructure];
    copyQuiz[id].collapsed = !copyQuiz[id].collapsed
      ;
    setQuizStructure(copyQuiz);
  }

  const matchAnswer = (value) => {
    setMatchedPairsState(value);
    const copyQuiz = [...assessment];

    console.log("matched val:", value);
    setAssessment(copyQuiz);
    handleAnswer({
      answer_content: value,
      id_modules: copyQuiz[step].id_modules,
      id_course_enrollments: copyQuiz[step].id_course_enrollments,
    });
  };
  const answerText = (value) => {
    const copyQuiz = [...assessment];
    copyQuiz[step].module_content.quiz_answers = { "quiz_answer": value }
    setAssessment(copyQuiz);

    handleAnswer({
      answer_content: copyQuiz[step].module_content.quiz_answers,
      id_modules: copyQuiz[step].id_modules,
      id_course_enrollments: copyQuiz[step].id_course_enrollments,
    });
  };

  const clickAnswer = (index) => {
    const copyQuiz = [...assessment];
    copyQuiz[step].module_content.quiz_answers[index].chosen =
      !copyQuiz[step].module_content.quiz_answers[index].chosen;
    console.log(copyQuiz[step].module_content.quiz_answers[index].chosen);
    setAssessment(copyQuiz);
    handleAnswer({
      answer_content: copyQuiz[step].module_content.quiz_answers,
      id_modules: copyQuiz[step].id_modules,
      id_course_enrollments: copyQuiz[step].id_course_enrollments,
    });
  };
  const hasAnswers = (quiz_type) => {
    switch (quiz_type) {
      case 1: return assessment[step]?.module_content?.quiz_answers.filter(row => row.chosen == true).length > 0
      case 2: return true
      // case 2: return assessment[step]?.module_content?.quiz_answers.filter(row => row.chose == true).length > 0
      case 3: return assessment[step]?.module_content?.quiz_answers.filter(row => row.chosen == true).length > 0
      case 4: return true
      // case 4: return assessment[step]?.module_content?.quiz_answers.filter(row => row.chosen == true).length > 0
      case 5: return assessment[step]?.module_content?.quiz_answers.filter(row => row.chosen == true).length > 0
      case 6: return assessment[step]?.module_content?.quiz_answers?.quiz_answer
    }

  };
  const finishModule = async (body) => {
    const query = "api/assessments/finish";
    await postAPI(query, body);
  };
 const finishAssessment = async (body) => {
    const query = "api/assessments/finish-assessment";
    const res = await postAPI(query, body);
    if (res.status === "ok"){
      setShowScoreModal(true);
    }
  }
  const goNext = async () => {
    const currentModule = assessment[step];
    const quizType = currentModule?.module_content?.quiz_type;
    const isQuiz = typeof quizType === "number";

    if (isQuiz && !hasAnswers(quizType)) {
      toastContext.showToast(
        <>Je moet een antwoord selecteren voordat je verder kunt gaan.</>,
        "error"
      );
      return;
    }

    setAnimationClass("animate-out"); 
    setMessage("");
    setMessageAnimation("");

    const finishBody = {
      id_course: currentModule.id_course,
      id_course_enrollments: currentModule.id_course_enrollments,
      id_modules: currentModule.id_modules,
    };

    await finishModule(finishBody); 
    setMaxReachedModule(prev => Math.max(prev, step));

    setTimeout(async () => {
      setActiveStep(prev => prev + 1);
      setAnimationClass("animate-in");

      const nextModule = assessment[step + 1];
      if (nextModule) {
        await startModule({
          id_course: nextModule.id_course,
          id_course_enrollments: nextModule.id_course_enrollments,
          id_modules: nextModule.id_modules,
        });
      } else {
        finishAssessment(finishBody);
      }
    }, 200);
  };


  const updateOrder = (value) => {
    const copyOrder = [...value];
    const body = {
      answer_content: copyOrder,
      id_modules: assessment[step].id_modules,
      id_course_enrollments: assessment[step].id_course_enrollments,
    };
    console.log(body);
    handleAnswer(body);
  };

const goBack = () => {
  if (step > 0) {
    setAnimationClass("animate-out-back");

    setTimeout(() => {
      checkForToggle(step - 1);
      setActiveStep(prev => prev - 1);
      setAnimationClass("animate-in-back");
      setMessage("");
    }, 200);
  }
};
  const goToSection = (index) => {
    if (index <= maxReachedModule) {
      setActiveStep(index);
      setMessage("");
    } else {
      toastContext.showToast(
        <>Je kunt deze module nog niet openen — voltooi eerst de vorige.</>,
        "warning"
      );
    }
  };
  const checkForToggle = (counter) => {
    const copyStructure = [...quizStructure]
    copyStructure.forEach((section, index_id) => {
      section.collapsed = true;
      section.modules.forEach((module) => {
        if (module.indexCounter == counter && section.collapsed == true) {
          toggleCollapse(index_id)
        }
      })
    });
    setQuizStructure(copyStructure)
  }
    const [phoneCollapse, setPhoneCollapse] = useState(false);  
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth < 768;
    useEffect(() => {
      const onResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, []);

    useEffect(() => {
      if(isMobile){
        setAvatarVideoMini(false);
      }else{
        setAvatarVideoMini(true);
      }
    }, [isMobile])
    
    const src = assessment?.[step]?.video
    const width = isMobile && !avatarVideoMini ? "auto" : !isMobile && !avatarVideoMini ? "50%" : "100%";
    const height = (src && isMobile && phoneCollapse ? "75vh" : src &&isMobile && !avatarVideoMini && !phoneCollapse  ? "50vh" : "") || (isMobile && !src && "100dvh");
    console.log("assessment", assessment?.[step])
  return (
    <>
     <ScoreOverviewModal visible={showScoreModal} onDismiss={() => setShowScoreModal(false)} />
    <VerticalLayout
      className={`quiz-assessment-grid ${assessment?.[step]?.module_type === 2 && "text-content"}`}
      style={{ alignItems: isMobile ?  "start" : "center", width: "100%", flexDirection: isMobile ? "column" : "row",}}
    >
      <QuizStepper
        progressMode="section"
        activeSection={step}
        quizStructure={quizStructure}
        goToSection={(index) => goToSection(index)}
        toggleCollapse={(id) => toggleCollapse(id)}
        maxReachedModule={maxReachedModule}
        setMaxReachedModule={setMaxReachedModule}
      />
    <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", width: "100%", justifyContent: isMobile ? "flex-start" : "center", alignItems: isMobile ? "center" : "flex-start", boxSizing: "border-box", height: "calc(-8.5rem + 100dvh)"}} className={`flex quiz-step-wrapper ${animationClass}`} key={step}>
      <div style={{marginRight: "clamp(2rem, 10vw, 10rem)", marginLeft: "clamp(2rem, 10vw, 10rem)", width: width, maxHeight: height, padding: "1rem" ,overflow:assessment?.[step]?.module_type ==  4 && "unset"}} data-testid="assesment-comp" className="assesment-comp-fix vertical quiz-comp phone-quiz standard-shadow standard-border">
        <AssessmentTitle
          assessment={{
            title: assessment?.[step]?.title,
            description: assessment?.[step]?.module_content?.quiz_question,
          }}
          visible={true}
        />
        <AssessmentFactory
          clickAnswer={(chosen) => clickAnswer(chosen)}
          data={assessment?.[step]?.module_content}
          module_type={assessment?.[step]?.module_type}
          updateOrder={(value) => updateOrder(value)}
          updateMatch={(value) => matchAnswer(value)}
          answerText={(value) => answerText(value)}
        />
       {assessment?.[step]?.time > 0 && assessment?.[step]?.on_time === true ? (
            <TimeBar
              time={assessment[step].time * 60}
              onTimeUp={() => {
                setMessage("De tijd voor deze quiz is verstreken. Je antwoorden zijn automatisch ingediend.")
                setMessageAnimation("fade-in-top-to-bottom")
                finishModule({
                  id_course: assessment[step].id_course,
                  id_course_enrollments: assessment[step].id_course_enrollments,
                  id_modules: assessment[step].id_modules,
                })
              }}
            />
          ):<></>}
        <Melding message={message || (assessment?.[step]?.on_time === false && assessment?.[step]?.time > 0) ? "De tijd voor deze quiz is verstreken. Je antwoorden zijn automatisch ingediend." : message} animationClass={messageAnimation} />
      </div>
      {!avatarVideoMini && <VideoPlayerAssessment setCollapsed={setCollapsed} collapsed={collapsed} src={src} setPhoneCollapse={setPhoneCollapse} phoneCollapse={phoneCollapse} />}
      </div>  
     {avatarVideoMini && <VideoPlayerAssessment setCollapsed={setCollapsed} collapsed={collapsed} src={src} setPhoneCollapse={setPhoneCollapse} phoneCollapse={phoneCollapse} />}
      {/* <div style={{"position": "fixed", "bottom": "0px", "left": "0px"}}> */}
    </VerticalLayout>
     <div style={{ gridArea: "2 / 1 / 3 / 3", "padding": "1rem", "background": "var(--card-background-color)", borderTop: "1px solid var(--border-color)" ,marginTop:"auto"}}>
        <GridLayout columnsTemplate="1fr auto">
          {!isMobile && <StandardButton style={{ marginLeft: "0px" }} backgroundColor="error-600" onClick={() => navigationContext.handleNavigation({ courseID: navigationContext.sidebar.courseID, navigation: 7, enrollment: 0 })} title={<>{icon("door-exit")}</>}></StandardButton>}
          <ButtonBar next={goNext} disabled={step <= 0} back={goBack} />
        </GridLayout>
      </div>
    </>
  )
};

export const QuizFactory = ({ data,
  clickAnswer,
  updateOrder,
  updateMatch,
  answerText
}) => {
  // Logic voor gekozen antwoord moet hierzo
  // answers moet een STATE zijn.
  console.log("QuizFactory data:", data);

  // return <OrderAnswers updatedAnswer={(newAnswersArray) => updateDragAnswers(newAnswersArray)} answers={dragAnswers}/>
  switch (data?.quiz_type) {
    case 1:
      return (
        <MultipleChoice
          clickAnswer={(chosen) => clickAnswer(chosen)}
          answers={data?.quiz_answers}
        />
      );
    case 2:
      return (
        <MatchChoice
          answerContent={(value) => updateMatch(value)}
          data={data?.quiz_answers}
        />
      );
    case 3:
      return (
        <TrueFalseChoice
          clickAnswer={(chosen) => clickAnswer(chosen)}
          answers={data?.quiz_answers}
        />
      );
    case 4:
      return (
        <OrderAnswers
          updateOrder1={(value) => updateOrder(value)}
          answers={data?.quiz_answers}
        />
      );
    case 5:
      return (
        <ImageAssessmentComp
          data={data?.quiz_answers}
          onSelect={(chosenImages) => clickAnswer(chosenImages)}
        />
      );
    case 6:
      return (
        <OpenAssessmentComp
          data={data?.quiz_answers}
          answerContent={(text) => answerText(text)}
        />
      );
    // case 6: return <OpenAssessment data={data?.quiz_answers} onSelect={(chosenImages) => clickAnswer(chosenImages)} />
  }
};
